import { CommonPaginator, usePaginated } from './usePaginated'
import { Product } from 'depoto-core'
import { useCallback, useMemo } from 'react'
import { removeEmptyProperties } from '../'
import { useCore } from '../../hooks'

export type ProductFilters = Partial<{
  id: number
  companies: number[]
  name: string
  ean: string
  code: string
  codes: string[]
  externalId: string
  fulltext: string
  depots: number[]
  metricDepots: number[]
  suppliers: number[]
  defaultSuppliers: number[]
  producers: number[]
  listType: string
  availability: string
  enabled: boolean
  isBundle: boolean
  expirationDateTo: string
  position1: string
  position2: string
  position3: string
  hasBeforeSellPrice: boolean
  hasHsCode: boolean
  createdFrom: string
  updatedFrom: string
  tags: number[]
  categories: number[]
  metrics: string
  enabledBatchExpiration: boolean
  requiredSerialNumbers: boolean
  company: number
}>

interface Params {
  filters?: ProductFilters
  sort?: string
  direction?: string
  schema?: any
}

export function usePaginatedProducts(params: Params = {}) {
  const { filters, schema = { id: null }, sort = 'name', direction = 'ASC' } = params
  const { core } = useCore()

  const serverFilters = useMemo(
    () =>
      removeEmptyProperties(filters || {}),
    [filters],
  )

  const fetchProducts = useCallback(
    async (page: number) => {
      const params: any = removeEmptyProperties({
        direction,
        filters: serverFilters,
        page,
        sort: sort,
      })

      return (await core.services.product.getList(params, schema)) as {
        items: Product[]
        paginator: CommonPaginator
      }
    },
    [core.services.product, serverFilters, sort],
  )

  const {
    isLastPage,
    loadMore,
    loading,
    refresh,
    items: products,
    totalCount,
  } = usePaginated<Product>({
    queryKey: ['products', filters, sort, direction],
    fetchItems: fetchProducts,
  })

  return {
    isLastPage,
    loadMore,
    loading,
    products,
    refresh,
    totalCount,
  }
}
